"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var uuid_1 = require("uuid");
var pingbackId = '';
var getPingbackId = function () {
    // it exists in memory
    if (!pingbackId) {
        try {
            // it exists in storage
            pingbackId = sessionStorage.getItem('giphyPingbackId');
        }
        catch (_) { }
        if (!pingbackId) {
            // we need to create it
            var hexTime = new Date().getTime().toString(16); // was told to mimic what we had
            pingbackId = ("" + hexTime + uuid_1.v4().replace(/-/g, '')).substring(0, 16); // 16 character max
            try {
                // save in storage
                sessionStorage.setItem('giphyPingbackId', pingbackId);
            }
            catch (_) { }
        }
    }
    return pingbackId;
};
exports.default = getPingbackId;
//# sourceMappingURL=get-pingback-id.js.map